import { motion } from 'framer-motion';
import { config } from '../data/config';

interface FilterBarProps {
  selectedTag: string;
  onTagSelect: (tag: string) => void;
  totalCount: number;
  visibleCount: number;
}

export const FilterBar = ({ 
  selectedTag, 
  onTagSelect, 
  totalCount, 
  visibleCount 
}: FilterBarProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.7 }}
      className="max-w-6xl mx-auto px-6 py-4"
    >
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        {/* Stats */}
        <div className="text-sm text-slate-600">
          <span className="font-semibold">{totalCount}</span> termes •{' '}
          <span className="font-semibold">{visibleCount}</span> affichés
        </div>

        {/* Filtres de tags */}
        <div className="flex flex-wrap justify-center gap-2">
          {config.tags.map((tag) => (
            <button
              key={tag.id}
              onClick={() => onTagSelect(tag.id)}
              className={`
                px-4 py-2 rounded-full text-sm font-medium
                transition-all duration-300
                ${selectedTag === tag.id
                  ? 'bg-rose-500 text-white shadow-md scale-105'
                  : 'bg-white text-slate-700 hover:bg-slate-50 border border-slate-200 hover:border-rose-300 hover:text-rose-600'
                }
              `}
            >
              {tag.label}
            </button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};
